import { Button } from "../../components/ui/Button";
import { maskValue } from '../../util/mask'

export const AboutFgts = ({ onGoToRegister,maxWithdraw, calculateFgts }) => (<section id="AboutFgts" className="min-h-screen bg-[#ff6c00] text-white font-sans flex flex-col lg:flex-row">
    <div className="mt-20 w-full flex items-center justify-center">
        <div className="max-w-1/2 p-8 lg:pl-20 flex flex-col justify-center">
            <div className="w-full flex items-center justify-center">
                <div className="">
                    <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-4">
                        Empréstimo FGTS: <br />
                        <span className="text-white">Antecipação com a Melhor Taxa!</span>
                    </h1>

                    <p className="text-lg mb-4">
                        Dinheiro parado no FGTS? Aproveite antes que acabe!
                    </p>

                    <ul className="mb-6 text-white space-y-2">
                        <li>✔ A aprovação é 100% online</li>
                        <li>✔ Disponível também para negativados</li>
                        <li>✔ Mais de 16 milhões de clientes no BMG</li>
                    </ul>

                    <p className="font-semibold text-white text-lg mb-2">
                        Simule o quanto você pode antecipar do seu FGTS:
                    </p>
                </div>
                <img className="hidden md:block w-[350px]" src="/assets/mulher-feliz.png" alt="hero-benefit-blocked" />
            </div>
            <div className="flex flex-col md:flex-row">
                <div className="bg-white p-4 text-black w-full max-w-xl rounded-tl-[10px] rounded-tr-[10px] md:rounded-tl-[10px] md:rounded-tr-[0px] md:rounded-br-[0px] md:rounded-bl-[10px]">
                    <div className="mt-10 mb-4">
                        <label className="block text-sm font-medium mb-1">
                            Qual o seu saldo no FGTS?
                        </label>
                        <input
                            onChange={e => calculateFgts(e.target.value)}
                            type="text"
                            placeholder="Saldo do FGTS"
                            className="w-full px-3 py-2 border rounded focus:outline-none"
                        />
                    </div>
                    <p className="text-xs text-gray-600 mb-2">
                        Contratação sujeita à análise. Os valores na contratação podem
                        mudar. Os valores apresentados são sem IOF. Prazo mínimo de
                        pagamento de 10 minutos e máximo de 24h úteis.
                    </p>

                    <p className="text-xs text-gray-600">
                        O BMG exerce uma atividade prevista pelo Banco Central.
                    </p>
                </div>
                <div className="rounded-tr-[0px] rounded-tl-[0px] rounded-br-[10px] rounded-bl-[10px] md:rounded-tr-[10px] md:rounded-tl-[0px] md:rounded-br-[10px] md:rounded-bl-[0px]   lg:w-1/2 p-8 lg:pr-20 flex flex-col justify-center items-center bg-white text-black rounded-t-3xl lg:rounded-none">
                    <div className="hidden md:block bg-[#4b0082] text-white px-4 py-2 rounded-full mb-6">
                        💸 Pagamento rápido
                    </div>

                    <p className="text-lg mb-2 text-center">Você pode receber até</p>
                    <p className="text-4xl font-bold mb-4 text-center">{maskValue(maxWithdraw)}</p>

                    <Button onClick={onGoToRegister} className="w-1/2">
                        Antecipar agora
                    </Button>
                </div>
            </div>
        </div>
    </div>
</section>)